import React, { createContext, useContext } from "react";
import { useAppSelector } from "hooks/useAppSelector";
import { userSelector } from "reduxStore/auth/selectors";
import { useChatUnreadCounts } from "hooks/useChatUnreadCounts";

type ChatUnreadContextValue = ReturnType<typeof useChatUnreadCounts>;

const ChatUnreadContext = createContext<ChatUnreadContextValue | null>(null);

export function ChatUnreadProvider({
  children,
  socketConnected,
}: {
  children: React.ReactNode;
  /** From `useRealtimeSocket()` — listeners must wait until the socket is connected. */
  socketConnected: boolean;
}) {
  const user = useAppSelector(userSelector);
  const value = useChatUnreadCounts(user?.user_id, socketConnected);
  return (
    <ChatUnreadContext.Provider value={value}>
      {children}
    </ChatUnreadContext.Provider>
  );
}

export function useChatUnread(): ChatUnreadContextValue {
  const ctx = useContext(ChatUnreadContext);
  if (!ctx) {
    throw new Error("useChatUnread must be used within ChatUnreadProvider");
  }
  return ctx;
}
